import { css } from '@emotion/react/macro'
import { alternateGray, primaryTextColor, linkTextColor } from './colors'

/** H1 */
export const headerCss = css`
  color: ${primaryTextColor};
  font-size: 30px;
  font-weight: 300;
  letter-spacing: 0.5px;
  line-height: 35px;
`

/** H2 */
export const pageTitleCss = css`
  color: ${primaryTextColor};
  font-size: 24px;
  font-weight: normal;
  letter-spacing: 0.5px;
  line-height: 28px;
`

/** H3 */
export const pageSubtitleCss = css`
  color: ${primaryTextColor};
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0.5px;
  line-height: 23px;
`

/* body styles */

/** Body 1 */
export const primaryBodyCss = css`
  color: ${primaryTextColor};
  font-size: 18px;
  font-weight: normal;
  letter-spacing: 0.5px;
  line-height: 28px;
`

/** Body 2 */
export const secondaryBodyCss = css`
  color: ${primaryTextColor};
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.5px;
  line-height: 28px;
`

/** Body 3 */
export const tertiaryBodyCss = css`
  color: ${primaryTextColor};
  font-size: 16px;
  font-weight: normal;
  letter-spacing: 0.5px;
  line-height: 20px;
`

/**  Body 4 */
export const subtitle1Css = css`
  color: ${primaryTextColor};
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.5px;
  line-height: 24px;
`

/** Body 5 */
export const body5Css = css`
  color: ${alternateGray};
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0.5px;
  line-height: 20px;
`

/** Body 6 */
export const body6Css = css`
  color: ${primaryTextColor};
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.5px;
  line-height: 20px;
`

/* Buttons and captions */

export const buttonTextCss = css`
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.75px;
  line-height: 16px;
  text-transform: uppercase;
`

export const captionTextCss = css`
  color: ${linkTextColor};
  font-size: 12px;
  font-weight: normal;
  letter-spacing: 0.4px;
  line-height: 16px;
`

export const overlineTextCss = css`
  color: ${linkTextColor};
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 1.5px;
  line-height: 16px;
  text-transform: uppercase;
`

export const chipTextCss = css`
  color: #000000;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0.75px;
  line-height: 16px;
`
